import toggleMenu from './select-menu-toggle';

export default function(rootElement) {
  const selectMenuButtons = rootElement.querySelectorAll('[data-role="select-menu-button"]');

  selectMenuButtons.forEach((menuButton) => {
    menuButton.onclick = (event) => {
      event.preventDefault();
      toggleMenu(menuButton, rootElement);
    };
  });

  document.body.addEventListener('click', (event) => {
    const openmenu = rootElement.querySelector('[data-role="select-menu-button"][aria-expanded="true"]');
    if (!openmenu) {
      return;
    }
    if (!openmenu.parentNode.contains(event.target)) {
      toggleMenu(openmenu, rootElement);
    }
  });
}
